import { downloadTransactionsRouteProps } from 'src/navigation/routeProps'
import { createFlyoutReducer } from 'src/redux/genericReducers'

export type DownloadTransactionsState = Record<string, never>

export const initialState: DownloadTransactionsState = {}

export interface Actions {
  type: 'component-modal/downloadTransactions/NOOP'
}

const CoreDownloadTransactionsReducer = (
  state = initialState,
): DownloadTransactionsState => {
  return state
}

const DownloadTransactionsReducer = createFlyoutReducer(
  downloadTransactionsRouteProps,
  initialState,
  CoreDownloadTransactionsReducer,
)

export default DownloadTransactionsReducer
